import accounting from 'accounting';

const FONT_FAMILY = 'DINPro-Medium, PingFang SC';

export default {
  color: ['#2F9EFF', '#49DAA4', '#FFBD3D'],
  grid: {
    top: 40,
    bottom: 20,
    right: 38,
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    textStyle: {
      color: '#303133',
    },
    borderColor: 'rgba(18,55,140,0.08)',
    borderWidth: 1,
    padding: 16,
    formatter(data) {
      const list = data.map((item) => {
        if (item.seriesName === '消耗额') {
          return `${item.marker} ${item.seriesName}：￥${accounting.formatMoney(
            item.data,
            '',
          )}<br>`;
        } else if (item.seriesName === '消耗额环比') {
          return `${item.marker} ${item.seriesName}：${item.data}%<br>`;
        } else {
          return `${item.marker} ${item.seriesName}：${item.data}<br>`;
        }
      });
      return list.join('');
    },
  },
};

export const legendStyle = {
  top: 0,
  data: [],
};

export const xAxisStyle = {
  type: 'category',
  data: [],
  axisPointer: {
    type: 'shadow',
  },
  axisLabel: {
    color: '#9CA6C0',
    fontFamily: FONT_FAMILY,
  },
  axisLine: {
    lineStyle: {
      color: '#DEE0E2',
      width: 2,
    },
  },
};

export const yAxisStyle = {
  type: 'value',
  axisLabel: {
    color: '#9CA6C0',
    formatter: '{value}',
    fontFamily: FONT_FAMILY,
  },
  axisLine: {
    show: false,
    lineStyle: {
      color: '#DEE0E2',
      width: 2,
    },
  },
  axisTick: {
    show: false,
  },
  splitLine: {
    lineStyle: {
      type: 'dashed',
      width: 2,
      color: '#EBEEF5',
    },
  },
};

export const seriesStyle = {
  itemStyle: {
    barBorderRadius: 20,
  },
};
